import React, { useRef, useState, useEffect } from "react";
import {FaPhoneAlt } from "react-icons/fa";
import { CONTACT_INFO } from '../../config/constants';
import { FadeIn } from "../../utils/AboutUsFadeEffects";

export default function AboutUsCTA() {

    const phone = CONTACT_INFO.mainPhone;

    return (
        <section className="relative py-10 flex flex-col px-8 md:px-16 bg-[linear-gradient(120deg,_#e0f2fe_60%,_#fff_100%)]">
            {/* Floating background elements */}
            <div className="absolute -bottom-24 -right-20 pointer-events-none"
                 style={{ width: '220px', height: '220px' }} >
                <div className="absolute w-20 h-20 bg-sky-200 rounded-full opacity-30 animate-float slow float-1"></div>
                <div className="absolute w-32 h-32 bg-blue-300 rounded-full opacity-20 animate-float slower float-2"></div>
                <div className="absolute w-16 h-16 bg-indigo-200 rounded-full opacity-25 animate-float slow float-3"></div>
            </div>
            <FadeIn direction="left">
                <h3 className="text-2xl md:text-4xl text-left font-bold text-sky-700 mb-2">Our Commitment</h3>
                <p className="text-gray-600 max-w-2xl mb-4 text-lg text-left">
                    Every member of our team shares a single focus: <span className="text-sky-600 font-semibold">saving lives</span>.
                    Open communication, continuous skill-building, and putting the patient first.
                    Every emergency: urgency, clarity, compassion.
                </p>
                <a href={`tel:${phone}`}
                   className="inline-block bg-sky-600 text-white px-10 py-3 rounded-full shadow-lg font-bold text-xl hover:bg-sky-700 transition"
                >
                    <FaPhoneAlt className="inline mr-2" /> +91 {phone}
                </a>
            </FadeIn>
        </section>
    )

}